var render, staticRenderFns
import script from "./LoadRolesMixin.vue?vue&type=script&lang=js"
export * from "./LoadRolesMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c99a18",
  null
  
)

export default component.exports